import { css, CSSResult } from 'lit'
import { csColorAction, csColorBackground, csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'


export const cseMenuItem = {
  backgroundColor: css`var(--cse-menu-item-background-color, ${csColorBackground.primary})`,
  backgroundColorDisabled: css`var(--cse-menu-item-background-color-disabled, ${csColorBackground.disabled})`,
  backgroundColorHover: css`var(--cse-menu-item-background-color-hover, ${csColorBackground.inverted})`,
  borderRadius: css`var(--cse-menu-item-border-radius, ${csBorder.radiusMinimal})`,
  color: css`var(--cse-menu-item-color, ${csColorText.body})`,
  colorDisabled: css`var(--cse-menu-item-color-disabled, ${csColorText.muted})`,
  colorHover: css`var(--cse-menu-item-color-hover, ${csColorText.white})`,
  gap: css`var(--cse-menu-item-gap, ${csSpacing.spacing04})`,
  paddingInline: css`var(--cse-menu-item-padding-x, ${csSpacing.spacing05})`,
  paddingBlock: css`var(--cse-menu-item-padding-y, ${csSpacing.spacing05})`,

  linkColor: css`var(--cse-menu-item-link-color, ${csColorAction.linkPrimary})`,
  linkColorHover: css`var(--cse-menu-item-link-color-hover, ${csColorAction.linkPrimaryHover})`,
  linkBackgroundColor: css`var(--cse-menu-item-link-background-color, transparent)`,
  linkBackgroundColorHover: css`var(--cse-menu-item-link-background-color-hover, transparent)`,
}

// Internal wiring only, not a documented cssprop: set by a parent cse-menu (see menu.style.ts)
// to tell its items which way to lay out. Deliberately kept out of the cseMenuItem registry
// object so formatProps() doesn't advertise it as menu-item's own public API.
const flexDirection = css`var(--cse-menu-child-layout, row)`

export const style: CSSResult = css`
  .cse-menu-item {
    align-items: center;
    background-color: ${cseMenuItem.backgroundColor};
    border-radius: ${cseMenuItem.borderRadius};
    color: ${cseMenuItem.color};
    flex-direction: ${flexDirection};
    gap: ${cseMenuItem.gap};
    display: flex;
    padding-block: ${cseMenuItem.paddingBlock};
    padding-inline: ${cseMenuItem.paddingInline};
    text-decoration: none;
    user-select: none;
  }

  .cse-menu-item.selected,
  .cse-menu-item:hover {
    background-color: ${cseMenuItem.backgroundColorHover};
    color: ${cseMenuItem.colorHover};
  }

  .cse-menu-item.variant-link {
    background-color: ${cseMenuItem.linkBackgroundColor};
    color: ${cseMenuItem.linkColor};
  }

  .cse-menu-item.variant-link.selected,
  .cse-menu-item.variant-link:hover {
    background-color: ${cseMenuItem.linkBackgroundColorHover};
    color: ${cseMenuItem.linkColorHover};
  }

  .cse-menu-item.variant-link.disabled {
    background-color: ${cseMenuItem.linkBackgroundColor};
    color: ${cseMenuItem.colorDisabled};
  }

  .cse-menu-item.disabled {
    background-color: ${cseMenuItem.backgroundColorDisabled};
    color: ${cseMenuItem.colorDisabled};
  }

  ::slotted([slot="suffix"]) {
    margin-left: auto;
  }
`
